import { getFromImmutableState } from '../../../../utils/immutableUtils';

const getMap = (state) => state.get('map');
const _getMapBounds = (state) => getMap(state).get('bounds');
export const getMapBounds = getFromImmutableState(_getMapBounds);
